/* eslint complexity: ["error", 40] */

import React, {Fragment, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter, Redirect} from 'react-router-dom';
import {Button, Container, Fade, Form, Spinner} from 'react-bootstrap';
import CommonMetaTag from './common-meta-tag';
import {push} from 'connected-react-router';
import {
  getRtvVideos,
  getRtvPartnerVideos,
  getPartners,
  showPlayerNewSubscriptionModal,
  partnerSelected,
  showPlayerHowPurchaseModal,
  rtvChannelSelected,
  removeRtvChannelFromFavourite,
  addRtvChannelToFavourite,
  selectCategory,
  getLiveVideos
} from '../actions/player';
import PlayerHowPurchase from './player-how-purchase';
import Configuration from '../config';
import {subscriptionStatuses, subscriptionKind} from '../constants';
import PlayerNewSubscription from './player-new-subscription';
import PlayerInsufficientFunds from './player-insufficient-funds';
import {useTranslation, Trans} from 'react-i18next';
import { showMessage } from '../actions/messages';
import rIcon from '../images/Replayer_favicon.png'
import allChannelsIcon from '../images/apps_white_24dp.svg'
import Dialog from 'react-bootstrap-dialog';
import {FaChevronRight, FaSearch, FaVideo} from 'react-icons/fa';
import {rtvChannelIsFree} from '../util/special-event-access';


const PlayerReplayerTvHome = ({
  token,
  partners,
  profile,
  goto,
  showReplayerTV,
  showPlayerHowPurchaseModal,
  subscriptions,
  favouriteRtvChannels,
  toggleFavouriteRtvChannel,
  showReplayerTVPartnerVideo,
  rtvCategories,
  selectCategory,
  deselectCategory,
  selectedCategory,
  gotoLiveVideos,
  loadPartners
}) => {
  const {t} = useTranslation();

  const [channelFilter, setchannelFilter] = useState("");
  const [loadingPartners, setLoadingPartners] = useState(token !== null && partners.length === 0);

  useEffect(() => {
    let active = true;
    if (token !== null && partners.length === 0) {
      setLoadingPartners(true);
      Promise.resolve(loadPartners()).then(() => {
        if (active) setLoadingPartners(false);
      }, () => {
        if (active) setLoadingPartners(false);
      });
    } else {
      setLoadingPartners(false);
    }
    return () => {
      active = false;
    };
  }, [loadPartners, partners.length, token]);

  if (token === null) {
    return (
      <Redirect to="/login"/>
    );
  }

  const getSubscriptionStatus = (partner, channel) => {
    if (subscriptions) {
      const sub = subscriptions.subscriptions.find(s => s.partner === partner.uid && s.rtv_channel_id === channel.id);
      if (sub && new Date(sub.expiry) >= new Date()) {
        return {status: subscriptionStatuses.valid};
      }

      const unlimitedSubscription = subscriptions.subscriptions.find(s => new Date(s.expiry) >= new Date() && s.kind === subscriptionKind.rtvUnlimited);
      if (unlimitedSubscription) {
        return {status: subscriptionStatuses.unlimited};
      }

      if (sub && new Date(sub.expiry) < new Date()) {
        return {status: subscriptionStatuses.expired, subscriptionId: sub.id};
      }

      return {status: subscriptionStatuses.noSubscription};
    }

    return {status: subscriptionStatuses.noSubscription};
  };

  const isFavouriteRtvChannel = rtv_channel_id => favouriteRtvChannels.some(c => c.id === rtv_channel_id);

  const getCategoryLogo = (categoryId, imageName) => {
    if (imageName.length > 0) {
      return `${Configuration.apiEndPoint}/admin/categories/image/${categoryId}?load=${imageName[0]}`;
    }
    return rIcon;
  };

  let dialog = null;

  const showRtvInfo = () => {
    dialog.show({
      title: t('WELCOME_TO_RTV'),
      body: <Trans i18nKey='REPLAYER_TV_INFO'/>,
      actions: [
        Dialog.Action(
          t('CLOSE_BUTTON'),
          null,
          'btn btn_red_outline_rp'
        )
      ],
      bsSize: 'small',
      onHide: dialog => {
        dialog.hide();
      }
    });
  };

  const renderEmptyPageString = () => {
    let channelNumber = 0;
    partners.forEach(p => {
      p.rtvChannels.forEach(c => {
        if((channelFilter === "" || c.name.toLowerCase().indexOf(channelFilter.toLowerCase()) > -1) && (Object.keys(selectedCategory).length === 0 || selectedCategory.rtvChannels.includes(c.id))){
          channelNumber++;
        }
      });
    });
    if (!loadingPartners && channelNumber === 0) {
      return <h6>{t('SEARCH_CHANNEL_FAILED')}</h6>;
    }
    return null;
  }

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear className="bg_white" style={{transition: 'opacity 0.30s linear', minHeight: 1000}}>
        <Container fluid className="presentation-container">
        <div className="page-header header-filter clear-filter replayertv_sportcenter_hero_rp" data-parallax="true">
            <div className="replayertv_sportcenter_hero_overlay_rp"/>
          </div>
          <div className="main main_raised_rp">
            <div className="section">
              <div className="container pt-5">
                <div className="row mb-4">
                  <div className="col-12">
                    <div className="skywork-media-directory-head">
                      <div className="skywork-media-directory-copy">
                        <span className="skywork-media-directory-kicker">{t('RTV_WATCH_BUY_SUBSCRIBE')}</span>
                        <h4 className="section_title_neg_rp">{t('REPLAYER_TV')}</h4>
                        <div className="rtv_info_btn" onClick={showRtvInfo}/>
                        <p>{t('DISCOVER_SPORTS_CENTERS_CHANNELS')}</p>
                      </div>
                      <button type="button" className="home-skywork-action home-skywork-action--live" onClick={gotoLiveVideos}>
                        <span className="home-skywork-live-camera" aria-hidden="true"><FaVideo/><span className="home-skywork-live-dot"/></span>
                        <span className="home-skywork-live-copy"><strong>{t('LIVE_NOW')}</strong><small>{t('DISCOVER_LIVE_STREAMS')}</small></span>
                        <FaChevronRight className="home-skywork-live-arrow" aria-hidden="true"/>
                      </button>
                      <Form className="skywork-media-search">
                        <FaSearch aria-hidden="true"/>
                        <Form.Control name="channelFilter" placeholder={t('CHANNEL_SEARCH')} type="text" maxLength="50" onChange={e => setchannelFilter(e.target.value)} onKeyPress={event => {if (event.key === 'Enter') {event.preventDefault();}}}/>
                      </Form>
                      {renderEmptyPageString()}
                      <div className="skywork-media-categories">
                      <span className="skywork-media-categories-label">{t('EXPLORE_BY_CATEGORY')}</span>
                      {rtvCategories ?
                        <div className="skywork-media-category-list">
                          <Button className={`skywork-media-category ${Object.keys(selectedCategory).length === 0 ? 'is-active' : ''}`} onClick={() => selectCategory({})}>
                              <img style={{height: 40, width: 40}} src={allChannelsIcon} alt={t('ALL_CHANNELS_LOGO')}/>
                              {" " + t('ALL_CHANNELS')}
                            </Button>
                          {rtvCategories.map(c => 
                            <Button className={`skywork-media-category ${c.id === selectedCategory.id ? 'is-active' : ''}`} key={c.id} onClick={() => c.id === selectedCategory.id ? deselectCategory() : selectCategory(c)}>
                              <img style={{height: 40, width: 40}} src={getCategoryLogo(c.id, c.imageName)} alt={t('CATEGORY_LOGO')}/>
                              {" " + c.label}
                            </Button>
                          )}
                        </div>
                        : null}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {loadingPartners ?
                    <div className="col-12 py-5 text-center" role="status" aria-live="polite">
                      <Spinner animation="border" className="mb-3"/>
                      <div>{t('LOADING_DATA_IN_PROGRESS')}</div>
                    </div> : null}
                  {partners.map(p => p.rtvChannels.map(channel =>
                    (
                      (channelFilter === "" || channel.name.toLowerCase().indexOf(channelFilter.toLowerCase()) > -1) && (Object.keys(selectedCategory).length === 0 || selectedCategory.rtvChannels.includes(channel.id)) ?
                      <div key={channel.id} className="col-md-6 col-lg-4 mb-2 mb-md-4 card-group">
                        <button
                          type="button"
                          className={channel.type === 0 ? "card video_store_bg_rp ease_fx skywork-media-channel-card" : "card video_store_bg_rp_specialist ease_fx skywork-media-channel-card"}
                          style={{border: 0, padding: 0, textAlign: "left", width: "100%"}}
                          onClick={channel.type === 0 ? showReplayerTV(p, channel, getSubscriptionStatus(p, channel)) : showReplayerTVPartnerVideo(p, channel, getSubscriptionStatus(p, channel))}
                        >
                          <div className="card-horizontal skywork-media-channel-card-layout">
                            <div className="col-sm-3 col-lg-4 pl-0 pr-0 video_store_logo_bg_rp skywork-media-channel-logo d-flex align-items-stretch justify-content-center">
                              {
                                channel.logoNames && channel.logoNames.length > 0 ?
                                  <div className="align-self-center">
                                    <img
                                      className="img-fluid"
                                      src={`${Configuration.apiEndPoint}/partners/rtv_channels/${channel.id}/images?load=${channel.logoNames[0]}`}
                                      alt={t('LOGO')}
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </div> :
                                  p.storeImage && p.storeImage.length > 0 ?
                                  <div className="align-self-center">
                                    <img
                                      className="img-fluid"
                                      src={`${Configuration.apiEndPoint}/images/${p.uid}?load=${p.storeImage[0]}`}
                                      alt={t('LOGO')}
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </div> :
                                  <div className="align-self-center video_store_nologo_overlay_rp"/>
                              }
                            </div>
                            <div className="card-body skywork-media-channel-copy d-flex align-items-center col-sm-9 col-lg-8">
                              <div><span>{channel.type === 0 ? 'Canale ReplayerTV' : 'ReplayerTV Sport Specialist'}</span><h5 className="card-title mb-0">{channel.name}</h5></div>
                              <FaChevronRight className="skywork-media-channel-arrow" aria-hidden="true"/>
                            </div>
                            <div className="card-body skywork-media-channel-favourite d-flex align-items-center col-sm-1 col-lg-1">
                              {
                                isFavouriteRtvChannel(channel.id) ?
                                  <div className="white_favorites_card_heart_btn_active" onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleFavouriteRtvChannel(channel.id, true);
                                  }}/> :
                                  <div className="white_favorites_card_heart_btn" onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleFavouriteRtvChannel(channel.id, false);
                                  }}/>
                              }
                            </div>
                          </div>
                        </button>
                      </div>
                    : null)
                  ))}
                </div>
              </div>
            </div>
          </div>
          <PlayerNewSubscription/>
          <PlayerInsufficientFunds/>
        </Container>
      </Fade>
      <PlayerHowPurchase/>
      <Dialog
        ref={el => {
          dialog = el;
        }}/>
    </Fragment>
  );
};

PlayerReplayerTvHome.propTypes = {
  token: PropTypes.string,
  partners: PropTypes.array,
  profile: PropTypes.object.isRequired,
  goto: PropTypes.func.isRequired,
  showReplayerTV: PropTypes.func.isRequired,
  showPlayerHowPurchaseModal: PropTypes.func.isRequired,
  subscriptions: PropTypes.object,
  favouriteRtvChannels: PropTypes.array,
  loadPartners: PropTypes.func.isRequired
};

PlayerReplayerTvHome.defaultProps = {
  token: null,
  partners: [],
  subscriptions: {},
  favouriteRtvChannels: []
};

const mapStateToProps = ({login: {token, profile}, player: {partners, subscriptions, favouriteRtvChannels, rtvCategories, selectedCategory}}) => ({
  token,
  profile,
  partners,
  subscriptions,
  favouriteRtvChannels,
  rtvCategories,
  selectedCategory
});

const mapDispatchToProps = dispatch => ({
  showPlayerHowPurchaseModal: () => {
    dispatch(showPlayerHowPurchaseModal());
  },
  showReplayerTV: (partner, rtvChannel, subscriptionStatus) => event => {
    if (event) {
      event.preventDefault();
    }
    dispatch(partnerSelected(partner));
    dispatch(rtvChannelSelected(rtvChannel));
    const partnerPublicSlug = partner.publicSlug || partner.public_slug || null;
    if (partnerPublicSlug) {
      dispatch(push(`/club/${partnerPublicSlug}?view=tv&channel_id=${rtvChannel.id}#club-matches`));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.valid || subscriptionStatus.status === subscriptionStatuses.unlimited || rtvChannelIsFree(rtvChannel)) {
      dispatch(getRtvVideos(partner.uid, rtvChannel.id));
      dispatch(push('/player-replayer-tv'));
      return;
    }

    if (rtvChannel.blocked) {
      dispatch(showMessage('RTV_CHANNELS', 'RTV_CHANNEL_IS_BLOCKED'));
      return;
    }
    
    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  showReplayerTVPartnerVideo: (partner, rtvChannel, subscriptionStatus) => event => {
    if (event) {
      event.preventDefault();
    }
    dispatch(partnerSelected(partner));
    dispatch(rtvChannelSelected(rtvChannel));
    const partnerPublicSlug = partner.publicSlug || partner.public_slug || null;
    if (partnerPublicSlug) {
      dispatch(push(`/club/${partnerPublicSlug}?view=tv&channel_id=${rtvChannel.id}#club-matches`));
      return;
    }

    if (subscriptionStatus.status === subscriptionStatuses.valid || rtvChannelIsFree(rtvChannel)) {
      dispatch(getRtvPartnerVideos(partner.uid, rtvChannel.id));
      dispatch(push('/player-replayer-tv-video-partner'));
      return;
    }

    if (rtvChannel.blocked) {
      dispatch(showMessage('RTV_CHANNELS', 'RTV_CHANNEL_IS_BLOCKED'));
      return;
    }
    
    dispatch(showPlayerNewSubscriptionModal());
    return;
  },
  goto: (path, action = null) => e => {
    e.preventDefault();
    if (action) {
      dispatch(action());
    }

    dispatch(push(path));
  },
  toggleFavouriteRtvChannel: (rtv_channel_id, isFavourite) => {
    if (isFavourite) {
      dispatch(removeRtvChannelFromFavourite(rtv_channel_id));
    } else {
      dispatch(addRtvChannelToFavourite(rtv_channel_id));
    }
  },
  selectCategory: category => {
    dispatch(selectCategory(category));
  },
  deselectCategory: () => {
    dispatch(selectCategory({}));
  },
  gotoLiveVideos: () => {
    dispatch(getLiveVideos());
    dispatch(push('/player-live-videos'));
  },
  loadPartners: () => {
    return dispatch(getPartners());
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerReplayerTvHome));
